/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'clsx';
import React from 'react';

import { Error as ErrorIcon } from '@mui/icons-material';

import { ArrowRoundedIcon } from '../../../svg-icons/ArrowRoundedIcon';
import { CheckMarkIcon } from '../../../svg-icons/CheckMarkIcon';
import { WarningIcon } from '../../../svg-icons/WarningIcon';
import { useSelectItemCatalogueIconStyles } from './SelectItemCatalogueIcon.styles';

type SelectItemCatalogueIconProps = {
  type: 'arrow' | 'check' | 'warning' | 'error';
};

export function SelectItemCatalogueIcon(props: SelectItemCatalogueIconProps) {
  const { type } = props;
  const classes = useSelectItemCatalogueIconStyles();
  if (type === 'arrow') {
    return <ArrowRoundedIcon className={cx(classes.iconArrow, 'iconArrow')} />;
  } else if (type === 'check') {
    return <CheckMarkIcon className={cx(classes.iconCheck, 'iconCheck')} />;
  } else if (type === 'warning') {
    return <WarningIcon className={classes.iconWarn} />;
  } else if (type === 'error') {
    return <ErrorIcon className={classes.iconError} />;
  }
  return null;
}
